import { HttpClient } from "@angular/common/http";
import { Injectable, forwardRef, inject } from "@angular/core";
import { CreateProductCategory, UpdateProductCategory} from "../interfaces/productCategory.interface";
import { Observable } from "rxjs";  
import { ProductCategory } from "../interfaces/productCategory.interface";
import { API_URL } from "@equine-ui-nx/injection-tokens";

@Injectable()
export class ProductCategoryService {

  apiUrl = inject(forwardRef(() => API_URL));
  baseUrl = `${this.apiUrl}/product-categories`;
  http = inject(HttpClient);


  create(payload: CreateProductCategory): Observable<{id: string}> {
    return this.http.post<{id: string}>(this.baseUrl, payload);
  }

  update(id: string, payload: UpdateProductCategory): Observable<any> {
    return this.http.post(`${this.baseUrl}/update/${id}`, payload);
  }

  delete(id: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/delete/${id}`, {});
  }

  getAll(): Observable<ProductCategory[]> {
    return this.http.get<ProductCategory[]>(`${this.baseUrl}`);
  }
}